/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ai_Actions_UnlimitedInputs */

const en_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited`)
};

const de_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzt`)
};

const fr_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illimité`)
};

const es_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilimitado`)
};

const it_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illimitato`)
};

const nl_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbeperkt`)
};

const pl_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez limitów`)
};

const fi_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loputon`)
};

const da_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubegrænset`)
};

const sv_settings_ai_actions_unlimited = /** @type {(inputs: Settings_Ai_Actions_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obegränsat`)
};

/**
* | output |
* | --- |
* | "Unlimited" |
*
* @param {Settings_Ai_Actions_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_actions_unlimited = /** @type {((inputs?: Settings_Ai_Actions_UnlimitedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Actions_UnlimitedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_actions_unlimited(inputs)
	if (locale === "fr") return fr_settings_ai_actions_unlimited(inputs)
	if (locale === "es") return es_settings_ai_actions_unlimited(inputs)
	if (locale === "it") return it_settings_ai_actions_unlimited(inputs)
	if (locale === "nl") return nl_settings_ai_actions_unlimited(inputs)
	if (locale === "pl") return pl_settings_ai_actions_unlimited(inputs)
	if (locale === "fi") return fi_settings_ai_actions_unlimited(inputs)
	if (locale === "da") return da_settings_ai_actions_unlimited(inputs)
	if (locale === "sv") return sv_settings_ai_actions_unlimited(inputs)
	return en_settings_ai_actions_unlimited(inputs)
});